// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c762dedb","172":"8ce67d9c","432":"781e81f0","592":"9875bc00","844":"e9d9ec93"}[chunkId] + ".chunk.js";
};